<div class="process-list-dynamic">
  <div class="search-head" *ngIf="hasFilters">
    <div class="search-head__input">
      <i class="fa fa-search"></i>
      <input
        type="text"
        class="form-control"
        [placeholder]="searchPlaceholder"
        [(ngModel)]="searchParams.nome"
        (keyup.enter)="doSearchByName()" />

      <div class="filter-button">
        <button type="button" class="btn btn-primary" (click)="doSearch()">
          Procurar
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="search-head__buttons" *ngIf="showExportButton">
      <button type="button" class="btn btn-outline-primary" (click)="doExport()">
        <i class="fa fa-file-excel"></i> {{ exportLabel }}
      </button>
    </div>
  </div>

  <div class="search-head__filter" *ngIf="hasFilters">
    <button type="button" (click)="toggleAdvancedSearch()">
      Busca Avançada
    </button>
  </div>

  <div class="process-list__title" *ngIf="headerTitle">
    <label class="process-list__title-label">{{ headerTitle }}</label>
  </div>

  <div class="search-advanced" [ngClass]="{ 'hidden': !showAdvancedSearch }" *ngIf="hasFilters">
    <div class="row">
      <app-dynamic
        *ngFor="let filter of filters; trackBy: trackFilter"
        [class]="getSizeClass(filter)"
        [attribute]="filter"
        (onEmit)="handleFilterEmit($event)">
      </app-dynamic>
    </div>
  </div>

  <p class="process-list__range" *ngIf="!isLoading && pagingModel && processes?.length > 0">
    {{ rangeStart }} - {{ rangeEnd }} de
    <button
      *ngIf="totalItems === null && !isCountLoading"
      type="button"
      class="process-list__count-eye"
      (click)="loadCount()"
      title="Ver total de itens">
      <i class="fa fa-eye"></i>
    </button>
    <i *ngIf="isCountLoading" class="fa fa-spinner fa-spin"></i>
    <span *ngIf="totalItems !== null">{{ totalItems | number: '1.0-0' }}</span>
  </p>

  <div
    class="process_list"
    [class.process_list--catalog]="isCatalogView"
    [class.process_list--empty]="!processes || processes.length === 0"
    *ngIf="!isLoading">
    <div class="process-item process-item_head" *ngIf="!isCatalogView && (processes?.length > 0)">
      <div
        class="process-item__row"
        [ngClass]="{ 'process-item__row_v2': totalColumns.length > 2 }"
        *ngFor="let i of totalColumns">
        <p>{{ getColumnTitle(i) }}</p>
      </div>
      <div class="process-item__row" [ngClass]="{ 'process-item__row_v2': totalColumns.length > 2 }">
        <p>Status</p>
      </div>
      <div class="process-item__row" [ngClass]="{ 'process-item__row_v2': totalColumns.length > 2 }"></div>
    </div>

    <app-process-summary
      *ngFor="let process of processes"
      [process]="process"
      [isCatalogView]="isCatalogView"
      [totalColumns]="totalColumns"
      (onUpdatedItem)="updateList()"
      (onShowModalPrint)="toggleModalPrint($event)">
    </app-process-summary>

    <div class="process-empty" *ngIf="!processes || processes.length === 0">
      <span class="fa-stack process-empty__icon" aria-hidden="true">
        <i class="fa fa-circle fa-stack-2x process-empty__icon-bg"></i>
        <i class="fa fa-info fa-stack-1x process-empty__icon-fg"></i>
      </span>
      <span>Não há itens para serem exibidos.</span>
    </div>
  </div>

  <div class="process-list__loading" *ngIf="isLoading">
    Carregando...
  </div>

  <div class="pagination-container" *ngIf="shouldShowPagination">
    <div class="pagination-pages" role="group" aria-label="Paginação">

      <!-- Paginação numérica completa (após contagem carregada) -->
      <ng-container *ngIf="totalPages !== null">
        <button
          *ngIf="countPage > 1"
          type="button"
          class="pagination-item"
          (click)="firstPages()">&lt; &lt;</button>
        <button
          *ngIf="countPage > 1"
          type="button"
          class="pagination-item"
          (click)="previousPages()">&lt;</button>
        <button
          *ngFor="let pageNumber of obterPaginas()"
          type="button"
          class="pagination-item"
          (click)="mudarPagina(pageNumber)"
          [class.pagination-item--active]="isActive(pageNumber)">
          {{ pageNumber }}
        </button>
        <button
          *ngIf="(countPage + 14) < totalPages"
          type="button"
          class="pagination-item"
          (click)="nextPages()">&gt;</button>
        <button
          *ngIf="(countPage + 14) < totalPages"
          type="button"
          class="pagination-item"
          (click)="lastPages()">&gt;&gt;</button>
      </ng-container>

      <!-- Navegação simples via HATEOAS (antes de carregar contagem) -->
      <ng-container *ngIf="totalPages === null">
        <button
          *ngIf="hasPrevPage || currentPage > 1"
          type="button"
          class="pagination-item"
          (click)="mudarPagina(currentPage - 1)">&lt;</button>
        <button
          type="button"
          class="pagination-item pagination-item--active">
          {{ currentPage }}
        </button>
        <button
          *ngIf="hasNextPage"
          type="button"
          class="pagination-item"
          (click)="nextPages()">&gt;</button>
      </ng-container>

    </div>
  </div>

  <div *ngIf="showModalPrint" class="bf-modal bf-modal__print">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Selecione os itens que deseja imprimir</h5>
          <button type="button" class="close" aria-label="Close" (click)="toggleModalPrint()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12" *ngFor="let itemAttr of itemsAttr">
              <div class="form-check text-left">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [value]="getPrintAttributeValue(itemAttr, 1)"
                  checked
                  (change)="onValueChange($event)" />
                <label class="form-check-label" for="">
                  {{ getPrintAttributeValue(itemAttr, 2) }}
                </label>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button class="btn btn-info" (click)="sendPrint()">Imprimir Guias</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

